import { render, staticRenderFns } from "./ArticleEditor.vue?vue&type=template&id=18ecee1a&scoped=true&"
import script from "./ArticleEditor.vue?vue&type=script&lang=js&"
export * from "./ArticleEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ecee1a",
  null
  
)

export default component.exports